

import { parallax } from './modules/parallax.js';
import { front } from './modules/front.js';
import Menu from './modules/menu.js';

front();

document.addEventListener('DOMContentLoaded', () => {
  new Menu(); 
  parallax();
 
});          